/*
 * O cartão do autor da coluna esquerda.
 *
 * O `id` e as classes `address*` são os de sempre: há CSS e JS presos a `#address-container`.
 *
 * O cartão só chega no payload para artigo com autor cadastrado E em pt-BR, o único idioma em
 * que a bio é escrita — o gate é do PHP, e o React não o refaz.
 */
import React from 'react';

import { IAuthorCard } from '../types';

const AVATAR_FALLBACK = '/assets/images/articles/address-card/profile-default.svg';

/** Troca uma vez só: sem zerar o handler, um fallback quebrado entra em laço. */
const handleAvatarError = (event: React.SyntheticEvent<HTMLImageElement>): void => {
    const image = event.currentTarget;

    image.onerror = null;
    image.src = AVATAR_FALLBACK;
};

const AuthorCard: React.FC<{ author: IAuthorCard }> = ({ author }) => (
    <div className="content-block content-block--author-card">
        <address id="address-container" className="article__address address">
            <img
                className="address__avatar"
                src={author.avatar}
                alt={author.name}
                onError={handleAvatarError}
            />

            <div className="address__content">
                {author.url
                    ? <a href={author.url} className="address__name"><strong>{author.name}</strong></a>
                    : <span className="address__name"><strong>{author.name}</strong></span>}

                {Boolean(author.description) && (
                    <p className="address__description">{author.description}</p>
                )}

                {Boolean(author.email) && (
                    <span className="address__email">
                        {'e-mail: '}
                        <a href={`mailto:${author.email}`} rel="nofollow">{author.email}</a>
                    </span>
                )}

                {author.medias.length > 0 && (
                    <>
                        <hr className="address__rule" />

                        <div className="address__medias">
                            {author.medias.map((media) => (
                                /* Âncora sem conteúdo de propósito: o ícone é
                                   `background-image` da própria âncora
                                   (`articles.scss:689`), e o nome acessível vem do
                                   `aria-label`. Texto dentro quebraria o ícone. */
                                /* eslint-disable-next-line jsx-a11y/anchor-has-content */
                                <a
                                    key={media.modifier}
                                    href={media.url}
                                    className={`address__${media.modifier}`}
                                    target="_blank"
                                    rel="nofollow noopener noreferrer"
                                    aria-label={media.modifier}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </address>
    </div>
);

export default AuthorCard;
